module.exports = __webpack_public_path__ + "static/media/3.838b2620.svg";